import { more } from './translationsMore';

export const languages = [
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

export const currencies = ['CHF', 'EUR', 'USD'];

export const translations = {
  en: {
    nav: { services: 'Services', destinations: 'Destinations', business: 'Business', help: 'Help', login: 'Login', book: 'Book Now' },
    hero: {
      title1: 'Your Comfort', title2: 'Is Our Privilege.',
      subtitle: 'Your reliable airport taxi and transfer service in Zurich, always at a fixed price. No hidden fees.',
      book: 'Book a Transfer', oneway: 'From A-to-B', hourly: 'Hourly ride',
      from: 'From (address, airport, hotel)', to: 'To (address, airport, hotel)',
      date: 'Date', time: 'Time', passengers: 'Passengers', returnTrip: 'Return Trip', next: 'Next Step', duration: 'Duration (hours)'
    },
    adv: {
      title: 'Airport Transfer Advantages',
      subtitle: 'At CAB.TAXI, we believe transportation shouldn’t be one-size-fits-all. Customise your ride with our add-ons for a unique transfer experience, every time.',
      items: [
        { t: 'Personalised Rides', d: 'Book with us and adjust the ride according to your needs.' },
        { t: 'Reliable Chauffeurs', d: 'Certified drivers in any destination you choose.' },
        { t: 'Customer Service', d: 'Multilingual help center available around the clock.' },
        { t: 'Easy Booking', d: 'Reserve a ride in advance or last minute in just a few clicks.' },
      ]
    },
    how: {
      title: 'How to book your transfer',
      subtitle: 'Booking your transfer is simple. In just a few clicks, you ensure safe and reliable transportation, anywhere.',
      steps: ['Book your Transfer','Get Confirmation','Receive Driver’s Info','Sit and Enjoy the Ride!','Meet your Driver at the Airport','Enjoy your Flight']
    },
    services: {
      title: 'The Right Transfer Service for Every Occasion',
      subtitle: 'It’s not just A to B – it’s the in-between that counts! Choose from one of our many services and get exactly the trip you need.',
      readMore: 'Read more', soon: 'Coming soon'
    },
    benefits: { title: 'Benefits of Travelling with Us', subtitle: 'With a state-of-the-art booking platform, we ensure that not only do you get a quality ride, you can also manage it easily, every step of the way.' },
    dest: { title: 'Discover Our Destinations', subtitle: 'Explore our most popular airport transfer destinations across Switzerland and Europe.', all: 'See all our destinations' },
    routes: { title: 'Our Most Popular Routes', subtitle: 'Check out the hotspots other travellers are visiting across Switzerland!' },
    reviews: { title: 'What Other Travellers Say About Us', subtitle: 'Don’t just take our word for it! We have successfully provided quality transfers to countless travellers.' },
    stats: { title: 'Our Achievements', dest: 'Destinations', pax: 'Passengers', transfers: 'Transfers', countries: 'Countries' },
    cta: { title: 'Do you have any questions?', subtitle: 'Find quick answers on our help page.', btn: 'Take me there!' },
    footer: { about: 'Reliable and cost-effective airport transfers across Switzerland and the world. Book with ease and enjoy professional drivers and punctual service.', company: 'Company', support: 'Support', legal: 'Legal', rights: 'All rights reserved.' }
  },
  de: {
    nav: { services: 'Dienste', destinations: 'Ziele', business: 'Business', help: 'Hilfe', login: 'Anmelden', book: 'Jetzt buchen' },
    hero: {
      title1: 'Ihr Komfort', title2: 'Ist unser Privileg.',
      subtitle: 'Ihr zuverlässiger Flughafen-Taxi- und Transferservice in Zürich, immer zum Festpreis. Keine versteckten Gebühren.',
      book: 'Transfer buchen', oneway: 'Von A nach B', hourly: 'Stundenfahrt',
      from: 'Von (Adresse, Flughafen, Hotel)', to: 'Nach (Adresse, Flughafen, Hotel)',
      date: 'Datum', time: 'Zeit', passengers: 'Passagiere', returnTrip: 'Rückfahrt', next: 'Nächster Schritt', duration: 'Dauer (Stunden)'
    },
    adv: {
      title: 'Vorteile des Flughafentransfers',
      subtitle: 'Bei CAB.TAXI glauben wir, dass Transport nicht für alle gleich sein sollte. Passen Sie Ihre Fahrt mit unseren Add-ons an – für ein einzigartiges Erlebnis, jedes Mal.',
      items: [
        { t: 'Personalisierte Fahrten', d: 'Buchen Sie bei uns und passen Sie die Fahrt Ihren Bedürfnissen an.' },
        { t: 'Zuverlässige Chauffeure', d: 'Zertifizierte Fahrer an jedem gewählten Ziel.' },
        { t: 'Kundenservice', d: 'Mehrsprachiges Hilfezentrum rund um die Uhr verfügbar.' },
        { t: 'Einfache Buchung', d: 'Reservieren Sie eine Fahrt im Voraus oder kurzfristig in wenigen Klicks.' },
      ]
    },
    how: {
      title: 'So buchen Sie Ihren Transfer',
      subtitle: 'Die Buchung ist einfach. Mit wenigen Klicks sichern Sie sich einen sicheren und zuverlässigen Transport, überall.',
      steps: ['Transfer buchen','Bestätigung erhalten','Fahrerinfos erhalten','Zurücklehnen & geniessen','Fahrer am Flughafen treffen','Guten Flug']
    },
    services: {
      title: 'Der richtige Transferservice für jeden Anlass',
      subtitle: 'Es ist nicht nur A nach B – es kommt auf das Dazwischen an! Wählen Sie aus unseren Diensten die passende Fahrt.',
      readMore: 'Mehr erfahren', soon: 'Demnächst'
    },
    benefits: { title: 'Vorteile einer Reise mit uns', subtitle: 'Mit einer hochmodernen Buchungsplattform sorgen wir dafür, dass Sie nicht nur eine hochwertige Fahrt erhalten, sondern diese auch einfach verwalten können.' },
    dest: { title: 'Entdecken Sie unsere Ziele', subtitle: 'Entdecken Sie unsere beliebtesten Flughafentransfer-Ziele in der Schweiz und Europa.', all: 'Alle Ziele ansehen' },
    routes: { title: 'Unsere beliebtesten Strecken', subtitle: 'Entdecken Sie die Hotspots, die andere Reisende in der Schweiz besuchen!' },
    reviews: { title: 'Was andere Reisende über uns sagen', subtitle: 'Verlassen Sie sich nicht nur auf unser Wort! Wir haben unzähligen Reisenden hochwertige Transfers geboten.' },
    stats: { title: 'Unsere Erfolge', dest: 'Ziele', pax: 'Passagiere', transfers: 'Transfers', countries: 'Länder' },
    cta: { title: 'Haben Sie Fragen?', subtitle: 'Schnelle Antworten auf unserer Hilfeseite.', btn: 'Zur Hilfe!' },
    footer: { about: 'Zuverlässige und kostengünstige Flughafentransfers in der Schweiz und weltweit. Einfach buchen und professionelle Fahrer sowie pünktlichen Service geniessen.', company: 'Unternehmen', support: 'Support', legal: 'Rechtliches', rights: 'Alle Rechte vorbehalten.' }
  },
  fr: {
    nav: { services: 'Services', destinations: 'Destinations', business: 'Business', help: 'Aide', login: 'Connexion', book: 'Réserver' },
    hero: {
      title1: 'Votre confort', title2: 'Est notre privilège.',
      subtitle: 'Votre service de taxi et de transfert aéroport fiable à Zurich, toujours à prix fixe. Aucuns frais cachés.',
      book: 'Réserver un transfert', oneway: 'De A à B', hourly: 'Course horaire',
      from: 'De (adresse, aéroport, hôtel)', to: 'À (adresse, aéroport, hôtel)',
      date: 'Date', time: 'Heure', passengers: 'Passagers', returnTrip: 'Aller-retour', next: 'Étape suivante', duration: 'Durée (heures)'
    },
    adv: {
      title: 'Avantages du transfert aéroport',
      subtitle: 'Chez CAB.TAXI, nous pensons que le transport ne devrait pas être universel. Personnalisez votre trajet avec nos options pour une expérience unique, à chaque fois.',
      items: [
        { t: 'Trajets personnalisés', d: 'Réservez avec nous et adaptez le trajet à vos besoins.' },
        { t: 'Chauffeurs fiables', d: 'Chauffeurs certifiés dans chaque destination choisie.' },
        { t: 'Service client', d: 'Centre d’aide multilingue disponible 24h/24.' },
        { t: 'Réservation facile', d: 'Réservez à l’avance ou à la dernière minute en quelques clics.' },
      ]
    },
    how: {
      title: 'Comment réserver votre transfert',
      subtitle: 'Réserver est simple. En quelques clics, vous garantissez un transport sûr et fiable, partout.',
      steps: ['Réserver','Recevoir la confirmation','Infos du chauffeur','Installez-vous & profitez','Rencontrez votre chauffeur','Bon vol']
    },
    services: {
      title: 'Le bon service de transfert pour chaque occasion',
      subtitle: 'Ce n’est pas seulement A à B – c’est l’entre-deux qui compte ! Choisissez parmi nos nombreux services.',
      readMore: 'En savoir plus', soon: 'Bientôt'
    },
    benefits: { title: 'Les avantages de voyager avec nous', subtitle: 'Avec une plateforme de réservation de pointe, nous garantissons non seulement un trajet de qualité, mais aussi une gestion facile à chaque étape.' },
    dest: { title: 'Découvrez nos destinations', subtitle: 'Découvrez nos destinations de transfert aéroport les plus populaires en Suisse et en Europe.', all: 'Voir toutes les destinations' },
    routes: { title: 'Nos itinéraires les plus populaires', subtitle: 'Découvrez les lieux prisés par les autres voyageurs en Suisse !' },
    reviews: { title: 'Ce que disent les voyageurs', subtitle: 'Ne nous croyez pas sur parole ! Nous avons fourni des transferts de qualité à d’innombrables voyageurs.' },
    stats: { title: 'Nos réalisations', dest: 'Destinations', pax: 'Passagers', transfers: 'Transferts', countries: 'Pays' },
    cta: { title: 'Vous avez des questions ?', subtitle: 'Trouvez des réponses rapides sur notre page d’aide.', btn: 'Y aller !' },
    footer: { about: 'Transferts aéroport fiables et économiques en Suisse et dans le monde. Réservez facilement et profitez de chauffeurs professionnels et d’un service ponctuel.', company: 'Entreprise', support: 'Support', legal: 'Légal', rights: 'Tous droits réservés.' }
  },
  it: {
    nav: { services: 'Servizi', destinations: 'Destinazioni', business: 'Business', help: 'Aiuto', login: 'Accedi', book: 'Prenota ora' },
    hero: {
      title1: 'Il tuo comfort', title2: 'È il nostro privilegio.',
      subtitle: 'Il tuo servizio di taxi e transfer aeroportuale affidabile a Zurigo, sempre a prezzo fisso. Nessun costo nascosto.',
      book: 'Prenota un transfer', oneway: 'Da A a B', hourly: 'Corsa a ore',
      from: 'Da (indirizzo, aeroporto, hotel)', to: 'A (indirizzo, aeroporto, hotel)',
      date: 'Data', time: 'Ora', passengers: 'Passeggeri', returnTrip: 'Andata e ritorno', next: 'Passo successivo', duration: 'Durata (ore)'
    },
    adv: {
      title: 'Vantaggi del transfer aeroportuale',
      subtitle: 'Da CAB.TAXI crediamo che il trasporto non debba essere uguale per tutti. Personalizza la tua corsa con i nostri extra per un’esperienza unica, ogni volta.',
      items: [
        { t: 'Corse personalizzate', d: 'Prenota con noi e adatta la corsa alle tue esigenze.' },
        { t: 'Autisti affidabili', d: 'Conducenti certificati in ogni destinazione scelta.' },
        { t: 'Servizio clienti', d: 'Centro assistenza multilingue disponibile 24 ore su 24.' },
        { t: 'Prenotazione facile', d: 'Prenota in anticipo o all’ultimo minuto in pochi clic.' },
      ]
    },
    how: {
      title: 'Come prenotare il tuo transfer',
      subtitle: 'Prenotare è semplice. In pochi clic assicuri un trasporto sicuro e affidabile, ovunque.',
      steps: ['Prenota il transfer','Ricevi conferma','Ricevi i dati dell’autista','Rilassati e goditi il viaggio','Incontra l’autista in aeroporto','Buon volo']
    },
    services: {
      title: 'Il servizio di transfer giusto per ogni occasione',
      subtitle: 'Non è solo da A a B – conta ciò che c’è nel mezzo! Scegli tra i nostri numerosi servizi.',
      readMore: 'Scopri di più', soon: 'Presto'
    },
    benefits: { title: 'I vantaggi di viaggiare con noi', subtitle: 'Con una piattaforma di prenotazione all’avanguardia, garantiamo non solo una corsa di qualità, ma anche una gestione semplice in ogni fase.' },
    dest: { title: 'Scopri le nostre destinazioni', subtitle: 'Scopri le nostre destinazioni di transfer aeroportuale più popolari in Svizzera e in Europa.', all: 'Vedi tutte le destinazioni' },
    routes: { title: 'Le nostre tratte più popolari', subtitle: 'Scopri le mete preferite dagli altri viaggiatori in Svizzera!' },
    reviews: { title: 'Cosa dicono di noi i viaggiatori', subtitle: 'Non fidarti solo delle nostre parole! Abbiamo offerto transfer di qualità a innumerevoli viaggiatori.' },
    stats: { title: 'I nostri risultati', dest: 'Destinazioni', pax: 'Passeggeri', transfers: 'Transfer', countries: 'Paesi' },
    cta: { title: 'Hai domande?', subtitle: 'Trova risposte rapide nella nostra pagina di aiuto.', btn: 'Vai!' },
    footer: { about: 'Transfer aeroportuali affidabili ed economici in Svizzera e nel mondo. Prenota con facilità e goditi autisti professionisti e un servizio puntuale.', company: 'Azienda', support: 'Supporto', legal: 'Legale', rights: 'Tutti i diritti riservati.' }
  }
};


Object.assign(translations, more);